import React from "react";
import { useNavigate } from "react-router";
import Helper from "../functions/Helper.js";

function Notifications(props) {
  const navigate = useNavigate();
  const getDayNumber = (date) => {
    let day = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return Math.ceil(day / (24 * 60 * 60 * 1000));
  };

  const notificationUrl = (notification) => {
    switch (notification.type) {
      case "review": {
        return "/shoe-reviews/" + notification.shoe_url;
      }
      case "shoe": {
        return "/shoe-reviews/" + notification.shoe_url;
      }
      case "discount": {
        return "/shoe-reviews/coupons/";
      }
      case "colorway": {
        return (
          "/shoe-reviews/" +
          notification.shoe_url +
          "/?style_id=" +
          notification.notification_style_id
        );
      }
      default: {
        return null;
      }
    }
  };

  const notificationDate = (notification) => {
    let now = getDayNumber(new Date());
    let notification_date = getDayNumber(
      Helper.getDateFromMysql(notification.date)
    );
    let diff = now - notification_date;
    if (diff === 0) {
      return "Today";
    } else if (diff === 1) {
      return "Yesterday";
    } else if (diff <= 13) {
      return diff + " days ago";
    } else {
      return Math.floor(diff / 7) + " weeks ago";
    }
  };

  const notificationImage = (notification) => {
    switch (notification.type) {
      case "review": {
        return (
          <img
            alt="shoe"
            style={{ transform: notification.mirror == "1" && "scaleX(-1)" }}
            src={Helper.add_options_img(notification.shoe_picture_url, 143)}
          />
        );
      }
      case "shoe": {
        return (
          <img
            alt="shoe"
            style={{ transform: notification.mirror == "1" && "scaleX(-1)" }}
            src={Helper.add_options_img(notification.shoe_picture_url, 143)}
          />
        );
      }
      case "discount": {
        return (
          <img
            alt="discount"
            src={__server__ + "/" + notification.shop_picture_url}
          />
        );
      }
      case "colorway": {
        return (
          <img
            alt="shoe"
            style={{ transform: notification.mirror == "1" && "scaleX(-1)" }}
            src={Helper.add_options_img(notification.style_picture_url, 143)}
          />
        );
      }
      default: {
        return null;
      }
    }
  };
  const notificationText = (notification) => {
    switch (notification.type) {
      case "review": {
        return (
          <div>
            Added {notification.amount}{" "}
            {Number(notification.amount) < 2 ? "review" : "reviews"} to{" "}
            <span style={{ fontWeight: "600" }}>{notification.shoe_name}</span>
          </div>
        );
      }
      case "shoe": {
        return (
          <div>
            Added{" "}
            <span style={{ fontWeight: "600" }}>{notification.shoe_name}</span>
          </div>
        );
      }
      case "discount": {
        return (
          <div>
            New Discount:{" "}
            <span style={{ fontWeight: "600" }}>
              {" "}
              {notification.percent === "0" ? "$" : ""}
              {notification.off}
              {notification.percent == "1" ? "%" : ""} off $
              {notification.value}
            </span>{" "}
            on {notification.shop}
          </div>
        );
      }
      case "colorway": {
        return (
          <div>
            Added new Style for{" "}
            <span style={{ fontWeight: "600" }}>{notification.shoe_name}</span>
          </div>
        );
      }
      default: {
        return null;
      }
    }
  };

  return (
    <div>
      {props.notifications.map((notification, index) => {
        let notification_date = Helper.getDateFromMysql(notification.date);
        let active = notification_date > props.lastVisit;
        return (
          <div
            onClick={() => {
              navigate(notificationUrl(notification));
            }}
            className="notification_item"
            key={index}
            style={{
              backgroundColor: active && "#edf2fa",
              minHeight: 75,
              display: "flex",
              cursor: "pointer",
              borderBottom: "1px solid #dddddd",
            }}
          >
            <div
              style={{
                width: 100,
                padding: 15,
                display: "flex",
                alignItems: "center",
              }}
            >
              {notificationImage(notification)}
            </div>
            <div
              style={{
                flex: 1,
                paddingLeft: 10,
                alignItems: "center",
                display: "flex",
              }}
            >
              <div>
                <div style={{ fontSize: 14, lineHeight: 1.3 }}>
                  {notificationText(notification)}
                </div>
                <div style={{ fontSize: 12, color: "#999999" }}>
                  {notificationDate(notification)}
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default Notifications;
